<template>
  <div class="container">
    <div class="content">
      <div class="left">
        <div class="welcome">Welcome</div>
        <div class="systitle">{{systemName}}</div>
        <div class="company">
          <img src="static/img/DefaultSystemLogo.png" />
          <span>天津费加罗电子有限公司</span>
        </div>
      </div>
      <div class="right">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import GlobalFooter from '../common/GlobalFooter'
export default {
  name: 'Common',
  components: { GlobalFooter },
  data () {
    return {}
  },
  computed: {
    systemName () {
      return this.$store.state.setting.systemName
    },
    copyright () {
      return this.$store.state.setting.copyright
    }
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.border-bottom-bule {
  border-bottom: 1px #5b9ef7 solid !important;
}
.border-bottom-error {
  border-bottom: 1px #f5222d solid !important;
}
.border-tlr {
  border-top: 1px #fff solid !important;
  border-left: 1px #fff solid !important;
  border-right: 1px #fff solid !important;
  box-shadow: none !important;
}
/deep/.ant-input {
  .border-tlr();
}
/deep/.ant-input-affix-wrapper .ant-input:focus,
/deep/.ant-input-affix-wrapper .ant-input:hover,
/deep/.ant-input-affix-wrapper:hover .ant-input:not(.ant-input-disabled) {
  .border-tlr();
  .border-bottom-bule();
}

/deep/.has-error .ant-input-affix-wrapper .ant-input:focus,
/deep/.has-error .ant-input-affix-wrapper .ant-input,
/deep/.has-error .ant-input-affix-wrapper .ant-input:hover,
/deep/.has-error .ant-input-affix-wrapper:hover .ant-input:not(.ant-input-disabled) {
  .border-tlr();
  .border-bottom-error();
}

/deep/.has-error .ant-input,
/deep/.has-error .ant-input:hover {
  border-top-color: #fff !important;
  border-left-color: #fff !important;
  border-right-color: #fff !important;
  border-bottom-color: rgba(0, 0, 0, 0.2) !important;
}
.container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  min-width: 1366px;
  overflow: auto;
  background: url("../../../static/img/bgc.jpg") no-repeat center;
  background-size: 100%;
  justify-content: center;
  align-items: center;
  .content {
    width: 700px;
    height: 400px;
    // background-color: pink;
    display: flex;
    align-items: center;
    .left {
      position: relative;
      background-color: rgba(0, 0, 0, 0.5);
      height: 100%;
      width: 350px;
      color: #fff;
      display: flex;
      flex-direction: column;
      // justify-content: center;
      align-items: center;
      .welcome {
        font-size: 28px;
        margin-bottom: 30px;
        margin-top: 88px;
      }
      .systitle {
        font-size: 30px;
        text-align: center;
      }
      .company {
        // position: absolute;
        margin-top: 160px;
        // background-color: #5b9ef7;
        display: flex;
        align-items: center;
        font-size: 15px;
        img {
          width: 22px;
          height: 22px;
          margin-right: 5px;
        }
      }
    }
    .right {
      background-color: #fff;
      width: 350px;
      height: 100%;
      padding: 20px 40px;
      // box-sizing: border-box;
      text-align: center;
      .r-title {
        display: inline-block;
        font-size: 20px;
        font-weight: 600;
        margin-bottom: 20px;
        // margin-top: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/common/LoginComm.vue